import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TransferTemplatesService } from '../../../services/transfer-templates/transfer-templates.service';
import { PAYMENT_TYPE, PaymentOperationTemplate } from '../../../users/operations/operations.interface';

@Component({
  selector: 'app-transfer-bank-templates',
  templateUrl: './transfer-bank-templates.component.html',
  styleUrls: ['./transfer-bank-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransferBankTemplatesComponent implements OnInit {
  @Input() fromBankTransferMobile = null;
  @Input() smDown = false;

  @Output() closeTemplateList = new EventEmitter<void>();
  @Output() mobileViewEdit = new EventEmitter<void>();

  paymentType: typeof PAYMENT_TYPE = PAYMENT_TYPE;

  isLoading$: Observable<boolean> = this.transferTemplates.isLoading$;
  templates$: Observable<PaymentOperationTemplate[]> = this.transferTemplates.transferTemplates$
    .pipe(
      map(templates => {
        return TransferTemplatesService.getTemplatesByTypes(templates, [PAYMENT_TYPE.PaymentSepa, PAYMENT_TYPE.PaymentSwift]);
      })
    );

  constructor(
    private transferTemplates: TransferTemplatesService) {
  }

  ngOnInit() {}

  repeatOperation(template: PaymentOperationTemplate) {
    this.transferTemplates.restoreOperationFromTemplate(template, this.fromBankTransferMobile);
    this.closeTemplateList.emit();
  }

  onEdit(): void {
    this.mobileViewEdit.emit();
  }
}
